import React, { useEffect, useState } from 'react';
import Card from '../Card/Card';

const Gandata = (props) => {
    const [guns, setGuns] = useState([]);
    useEffect(() => {
        fetch('https://raw.githubusercontent.com/mir-hussain/guns/main/data.json')
            .then(res => res.json())
            .then(data => setGuns(data));
    }, [])
    return (

        <div>
            <h2 className='text-3xl mt-5 text-center'>Welcome to GunStorE</h2>
            <p className='text-2xl p-8 text-center'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut libero vitae laudantium tempora quas assumenda sint exercitationem sed animi maiores.</p>
            <div className='w-[95%] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 p-20'>
                {
                    guns.map(gun => <Card gun={gun} increaseValue ={props.increaseValue}/>)
                }
            </div>
        </div>

    );
};
export default Gandata;